module.exports = __webpack_public_path__ + "static/manjumu-53688f88c17417b8df1b05b3a31144d7.png";